export const loadNotifications = async (request, { unreadOnly = true, limit = 20, offset = 0, category = '' } = {}) => {
    const params = new URLSearchParams({
        unread_only: unreadOnly ? 'true' : 'false',
        limit: String(limit),
        offset: String(offset),
    });
    if (category) params.set('category', category);
    const data = await request(`/api/v1/notifications?${params.toString()}`, {});
    return data || [];
};

export const loadNotificationsSummary = async (request) => {
    return (await request('/api/v1/notifications/summary', {})) || { unread_total: 0, unread_by_category: {}, categories: {} };
};

export const markNotificationRead = async (request, notificationId) => {
    return await request(`/api/v1/notifications/${notificationId}/read`, { method: 'POST' });
};

export const markAllNotificationsRead = async (request, category = '') => {
    const query = category ? `?category=${encodeURIComponent(category)}` : '';
    return await request(`/api/v1/notifications/read-all${query}`, { method: 'POST' });
};

export const deleteNotification = async (request, notificationId) => {
    return await request(`/api/v1/notifications/${notificationId}`, { method: 'DELETE' });
};

export const loadNotificationPreferences = async (request) => {
    return await request('/api/v1/notifications/preferences', {});
};

export const loadTelegramStatus = async (request) => {
    return await request('/api/v1/telegram/status', {});
};

export const createTelegramLink = async (request) => {
    return await request('/api/v1/telegram/link', {});
};

export const unlinkTelegram = async (request) => {
    return await request('/api/v1/telegram/link', { method: 'DELETE' });
};

export const saveNotificationPreference = async (request, eventType, channel, enabled) => {
    return await request('/api/v1/notifications/preferences', {
        method: 'PUT',
        body: JSON.stringify({ event_type: eventType, channel, enabled }),
    });
};
